import React from 'react';
import utils from '@utils/utils';
import '@css/viewer.css'

export default class TextViewer extends React.Component {
    constructor() {
        super();

        this.closeViewer = this.closeViewer.bind(this);
    }

    closeViewer() {
        if(this.props.closeViewer) {
            this.props.closeViewer();
        }
    }

    render() {
        return (
            <div className="viewer-overlay">
                <div className="viewer-toolbar right">
                    <i className="fa fa-window-close fa-lg" onClick={this.closeViewer}></i>
                </div>
                <div id={this.props.containerID} className='viewer-container'>
                    <div dangerouslySetInnerHTML={{__html: this.props.textBody}} />
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/js/components/TextViewer.js